export enum ServiceApiUrls {
  GetServices = "/api/Service/GetServices",
  CreateEditService = "/api/Service/CreateEditService",
  DeleteService = "/api/Service/DeleteService",
  CreateEditTransportService = "/api/Service/CreateEditTransportService",
  CreateOtherDistributionLaneService = "/api/Service/CreateOtherDistributionLaneService"
}
